import perfil from '@/helpers/perfil'
import usuarioHelper from '@/helpers/usuario-logado';

export default {
  podeCarregarQar: function() {
    if (usuarioHelper.USUARIO_LOGADO()) {
      if (usuarioHelper.USUARIO_LOGADO().perfil.id == perfil.COMERCIAL ||
          usuarioHelper.USUARIO_LOGADO().perfil.id == perfil.COMERCIAL_PARCEIRO ||
          usuarioHelper.USUARIO_LOGADO().perfil.id == perfil.PLATAFORMA ||
          usuarioHelper.USUARIO_LOGADO().perfil.id == perfil.ANALISTA ||
          usuarioHelper.USUARIO_LOGADO().perfil.id == perfil.ADMINISTRADOR) {
        return true;
      }
    }
    return false;
  }
}


// WEBPACK FOOTER //
// ./src/components/pages/questionario/QuestionarioFunctions.js